export const TOOL_ERROR_CODES = {
	PUBLIC_KEY_INVALID:     'PUBLIC_KEY_INVALID',
	THEME_LOAD_FAILED:      'THEME_LOAD_FAILED',
	PANEL_KEY_INVALID:      'PANEL_KEY_INVALID',
	DESIGN_LOAD_FAILED:     'DESIGN_LOAD_FAILED',
	ADDRESS_RESOLVE_FAILED: 'ADDRESS_RESOLVE_FAILED',
	ROOF_DATA_FAILED:       'ROOF_DATA_FAILED',
	CREATE_DESIGN_FAILED:   'CREATE_DESIGN_FAILED',
	PERMISSION_DENIED:      'PERMISSION_DENIED',
	INVALID_QUERY_PARAMS:   'INVALID_QUERY_PARAMS',
} as const;

export type ToolErrorCode = typeof TOOL_ERROR_CODES[keyof typeof TOOL_ERROR_CODES];